import Vue from "vue";
import VueRouter from "vue-router";
import sCache from "@/plugins/simple-cache";
import store from "../store/index";

Vue.use(VueRouter);
Vue.use(sCache, { store });
/**
 * Setting the current logged in user.
 */

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      // route level code-splitting
      // this generates a separate chunk (home.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      meta: {},
    },
    {
      path: "/bulkrequest",
      name: "bulkrequest",
      // route level code-splitting
      // this generates a separate chunk (bulkrequest.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "bulkrequest" */ "../views/BulkReques.vue"),
      meta: {},
    },
    {
      path: "/bulkcollect",
      name: "bulkcollect",
      // route level code-splitting
      // this generates a separate chunk (bulkcollect.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "bulkcollect" */ "../views/BulkCollect.vue"
        ),
      meta: {},
    },
    {
      path: "/error",
      name: "error",
      // route level code-splitting
      // this generates a separate chunk (error.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "error" */ "../views/Error.vue"),
      meta: {},
    },
    {
      path: "*",
      name: "notfound",
      component: () =>
        import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
